import api from '../../plugins/api';

// GET /services/getDealerAddresses â ÑÐ¾ÑÐºÐ¸, ÐºÑÐ´Ð° Ð·Ð°Ð¿Ð¸ÑÑÐ²Ð°ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°.
// ÐÐµÐ´ÑÑÑÑ Ð² Ð±Ð°Ð·Ðµ (Scripts/add_service_addresses.sql). ÐÑÐ´Ð°ÑÑ Ð²ÑÐµ Ð°ÐºÑÐ¸Ð²Ð½ÑÐµ:
// ÑÐ¸Ð»ÑÑÑÐ° Ð¿Ð¾ Ð³Ð¾ÑÐ¾Ð´Ñ Ð½ÐµÑ, ÐºÐ»Ð¸ÐµÐ½Ñ Ð¼Ð¾Ð¶ÐµÑ Ð¾Ð±ÑÐ»ÑÐ¶Ð¸Ð²Ð°ÑÑÑÑ Ð½Ðµ ÑÐ°Ð¼, Ð³Ð´Ðµ Ð¿Ð¾ÐºÑÐ¿Ð°Ð».
//
// typeId: 3 â ÑÐµÑÐ²Ð¸Ñ (Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ), 1 â ÑÐµÑÑ-Ð´ÑÐ°Ð¹Ð².
// markId â ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ ÑÐµÑÑ-Ð´ÑÐ°Ð¹Ð²Ð°: ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ ÑÐ°Ð»Ð¾Ð½Ð¾Ð², Ð³Ð´Ðµ ÑÑÑ Ð¼Ð°ÑÐºÑ ÐºÐ°ÑÐ°ÑÑ.
// ÐÑÐ¾ÑÐ¾Ð¹ Ð°ÑÐ³ÑÐ¼ÐµÐ½Ñ api.get â ÑÐ¶Ðµ ÑÐ°Ð¼Ð¸ query-Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÑ: Ð¾Ð±ÑÑÑÐºÐ° Ð·Ð°Ð²Ð¾ÑÐ°ÑÐ¸Ð²Ð°ÐµÑ Ð¸Ñ
// Ð² { params } ÑÐ°Ð¼Ð°. ÐÐµÑÐµÐ´Ð°ÑÑ { params } â ÑÐµÐ´ÐµÑ params[typeId]=1, Ð±ÑÐºÐµÐ½Ð´
// ÑÐ°ÐºÐ¾Ð³Ð¾ Ð½Ðµ Ð²Ð¸Ð´Ð¸Ñ Ð¸ Ð¼Ð¾Ð»ÑÐ° Ð¾ÑÐ´Ð°ÑÑ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ.
const getDealerAddresses = (params) => {
  return api.get('/api/services/getDealerAddresses', params);
};

export default getDealerAddresses;
